import React  from 'react';
import { Typography } from "@mui/material"


const ProfessionalCovenants = ({ covenants, fontSize = 12 }) => {

    // let condicion = false;
    // covenants.find( (value, index) => {
    //     if(value.isaNombre === 'Fonasa'){
    //         condicion = true;
    //     }
    // } );
    // console.log('found => ', condicion);
    let convenio = [];
    if(covenants != null){
        let array_objetos = covenants;

        let newObj = [];
        // rescatamos solo los isaCodigo
        for (let i = 0; i < array_objetos.length; i++) {
           let valor = array_objetos[i].isaCodigo;
           newObj.push(valor);
        }
        // ordena los isaCodigo de menor a mayor
        newObj = newObj.sort((a, b) => a - b)
        //console.log( newObj );
    
        let convenioObj = [];
         for (let y = 0; y < newObj.length; y++) {
            for (let x = 0; x < array_objetos.length; x++) {
                if(newObj[y] == array_objetos[x].isaCodigo){
                    let nombre = array_objetos[x].isaNombre;
                    convenioObj.push(nombre);
                    break
                }
             }
         }
         //console.log(convenioObj);
         convenio = convenioObj.join(", ");
    }

    return (
        // <>
        //     <Typography style={{ fontWeight: 'bold', fontSize: fontSize }}>
        //         Convenios:
        //     </Typography>
        //     <Typography style={{ fontWeight: 500, fontSize: fontSize }}>
        //         {!covenants || covenants?.length === 0 ? `Sin convenios` : covenants.map(el => el.isaNombre).join(", ")}
        //     </Typography>

        // </>
        <>
            <Typography style={{ fontWeight: 'bold', fontSize: fontSize }}>
                Convenios:
            </Typography>
            <Typography style={{ fontWeight: 500, fontSize: fontSize }}>
                {/* {!covenants || covenants?.length === 0 ? `Sin convenios` : covenants.map(el => el.isaNombre).join(", ")} */}
                {!convenio || convenio?.length === 0 ? `Sin convenios` : convenio }
            </Typography>

        </>
    )
}

export default ProfessionalCovenants;